






import { Component, Prop, Vue } from 'vue-property-decorator';
import { PaperGeneratedItem } from '@/resource/paper-generated-item/paper-generated-item.model';
import { extractQuestionAnswer } from '@/utils/question-generated-util';
import {
  SCRIPT_MATHJAX_1,
  addScript,
  isHasMath,
  renderMathJax,
} from '@/utils/add-script';

@Component({
  components: {},
})
export default class PreCollectionQuestionGenerated extends Vue {
  @Prop({ required: true })
  paperGeneratedItem!: PaperGeneratedItem;

  @Prop({ required: true })
  addAnswerHtmls!: (answerHtml: string) => void;

  questionHtml = '';
  answerHtml = '';

  created() {
    if (this.paperGeneratedItem) {
      const { questionHtml, answerHtml } = extractQuestionAnswer(
        this.paperGeneratedItem.questionGenerated.html,
      );

      this.addAnswerHtmls(answerHtml);
      this.questionHtml = questionHtml;
      this.answerHtml = answerHtml;
    }
  }

  mounted() {
    if (isHasMath(this.questionHtml) || isHasMath(this.answerHtml)) {
      addScript({
        id: 'chart',
        link: SCRIPT_MATHJAX_1,
        onload: () => {
          renderMathJax(this.questionHtml);
        },
      });
    }
  }
}
